import "./style.less";
export default function UserBookingList() {
    return {
        restrict: "E",
        scope: {
            bookings: "=",
        },
        template: require("./template.html"),
        controller: ($scope, moment) => {
            const bookingPeriods = $scope.bookings.flatMap(
                (x) => x.bookingPeriods
            );

            $scope.bookingPeriods = bookingPeriods.filter(
                (bp) => moment(bp.end) > moment() && bp.statusId === 3
            );

            $scope.bookingPeriodsPast = bookingPeriods.filter(
                (bp) => moment(bp.end) < moment() || bp.statusId === 4
            );
        },
    };
}
